module.exports = __webpack_public_path__ + "img/img06.d6525bfd.jpeg";